export default __webpack_public_path__ + "images/rosabandet/ribbon-2018-shadow.png";